<template>
  <Row type="flex" justify="space-around">
    <Col span="5" class="dash-row">
      <Card>
        <p slot="title">欢迎</p>
        <p>欢迎，用户<b>{{ userInfo.username }}</b></p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </Card>
    </Col>

    <Col span="5">
      <Card>
        <p slot="title">你的角色</p>
        <p v-for="role in roles" :key="role">{{ role }}</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </Card>
    </Col>

    <Col span="5">
      <Card>
        <p slot="title">您的权限</p>
        <p v-for="permission in permissions" :key="permission">{{ permission }}</p>
      </Card>
    </Col>

    <Col span="5">
      <Card>
        <p slot="title">要办的事</p>
        <p>TODO1</p>
        <p>TODO2</p>
        <p>TODO3</p>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </Card>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      userInfo: this.$store.state.user ? this.$store.state.user.userInfo : {},
      roles: this.$store.state.user ? this.$store.state.user.roles : [],
      permissions: this.$store.state.user ? this.$store.state.user.permissions : []
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue